export default __webpack_public_path__ + "static/media/hi2.97545476.gif";